import { useEffect } from 'react'
import { supabase } from './supabase'
import { pushToast } from './toast.jsx'

// Watch JWT expiry. Warn user 2 min before expiration. Supabase auto-refreshes
// on demand, but the warning gives them a beat to save if they're typing.

export function useSessionWatch() {
  useEffect(() => {
    let timer = null
    let warned = false

    async function schedule() {
      const { data } = await supabase.auth.getSession()
      const exp = data.session?.expires_at
      if (!exp) return
      const ms = exp * 1000 - Date.now()
      const lead = Math.max(0, ms - 2 * 60_000)
      if (timer) clearTimeout(timer)
      timer = setTimeout(() => {
        if (warned) return
        warned = true
        pushToast({
          kind: 'warn',
          title: 'Session läuft ab',
          body:  'Auto-Refresh läuft. Falls fail → neu einloggen.',
          ttl: 8000,
        })
      }, lead)
    }

    schedule()
    const { data: sub } = supabase.auth.onAuthStateChange(() => { warned = false; schedule() })
    return () => { if (timer) clearTimeout(timer); sub.subscription.unsubscribe() }
  }, [])
}
